import React from 'react';

export const HookUtils = {
    usePrevious: (value) => {
        const ref = React.useRef();

        React.useEffect(() => {
            ref.current = value;
        }, [value]);

        if (!ref.current) {
            return value;
        }

        return ref.current;
    },
};
